import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { MediaQuery } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 75px;
  width: 100%;
  overflow: hidden;

  ${MediaQuery.M_AND_DOWN} {
    height: 100px;
  }
`;

export const BackgroundWrapper = styled.div`
  position: absolute;
  z-index: 1;
  height: 75px;
  width: 100%;
  overflow: hidden;

  ${MediaQuery.M_AND_DOWN} {
    height: 100px;
  }
`;

export const IllustrationWrapper = styled.div`
  z-index: 1;
  img {
    height: 75px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  ${MediaQuery.M_AND_DOWN} {
    margin: 0px 15px 0 10px;
  }
`;

export const Content = styled.div`
  margin: 0px 10px;
  text-align: ${({ isCentered }) => isCentered && 'center'};

  ${MediaQuery.M_AND_DOWN} {
    flex-shrink: 0.5;
  }
`;

export const ButtonWrapper = styled.div`
  a,
  button {
    padding: 0 10px;
    background-clip: border-box;
    text-align: center;
  }

  ${MediaQuery.M_AND_DOWN} {
    width: 100%;

    a,
    button {
      padding: 10px;
    }
  }

  ${({ isNegative }) =>
    isNegative &&
    `
    a,
    button {
      border: 2px solid ${Color.CLOUD_BURST};

      &:hover {
        border: 2px solid ${Color.BLUE_RIBBON};
      }
    }
  `}
`;

export const Title = styled.p`
  ${Typography.M_BOLDER};
  color: ${({ isNegative }) => (isNegative ? Color.WHITE : Color.CLOUD_BURST)};
`;
